<template>
    <div class="col-sm-12 list-content-item mb-2">
        <div class="row">
            <div class="col">
                <div class="row">

                    <div v-if="isFromBooking" class="col-lg-9">
                        <h2 class="title inline-block" v-text="title"></h2> for
                        <div>Booking: <span class="font-weight-700">{{ product.display_name }}</span></div>
                        <div class="mb-3" v-text="point.created_at"></div>
                    </div>
                    <div v-else class="col-lg-9">
                        <h2 class="title inline-block" v-text="title"></h2> for
                        <div><span class="font-weight-700">{{ product.display_name }}</span></div>
                        <div class="mb-3" v-text="point.created_at"></div>
                    </div>

                    <div class="col-lg-3 text-lg-right text-left mt-sm--2 mt-lg-0">
                        <div><span class="text-lg" v-text="amount"></span> points</div>
                        <router-link v-if="hasUserGained && isFromBooking" :to="{name: 'Booking Page', params: { id: this.product.id }}" exact v-slot="{ href, navigate }">
                            <a :href="href" @click="navigate" class="btn btn-sm btn-warning mt-3">
                                <i class="fa fa-eye mr-2"></i> View booking
                            </a>
                        </router-link>
                    </div>
                </div>
                <!-- <div class="description">Booking No: {{ booking.code }}</div>
                <div class="description">Appointment on {{ displayedAppointmentDatetime }}</div>
                <div class="description text-capitalize" v-text="displayedStatus"></div>
                <div class="text-right">
                    <a :href="bookingLink" class="btn btn-sm btn-warning">
                        <i class="fa fa-eye mr-1"></i> View Details
                    </a>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { resource, pageRoute } from "@utils/network";

export default {
    name: "PointListItem",

    computed: {
        title() {
            return this.point.type
        },
        isFromBooking() {
             return this.product.type == 'booking';
        },
        hasUserGained() {
            return true;
             return this.$store.getters.authenticatedUser.id == this.point.gainer_id;
        },
        amount() {
            const amount = this.point.type_value.includes("discount")
             ? this.point.amount * -1
             : this.point.amount;

             return parseFloat(amount || 0).toFixed(2);
        },
        product() {
            return this.point.product || {}
        },
        bookingLink() {
            return pageRoute("bookings/:id", { id: this.product.id });
        },
    },
    
    props: {
        point: [Object],
    },

    mounted() {
        
    }
}
</script>